import styled from 'styled-components';
import { Breakpoint } from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';
import { NextAvailableView as NextView } from '../../ResultView/ResultList/ProfileCards/search-card/Appointments/NextAvailable/NextAvailable.styles';
import { Label as SearchLabel } from '../../ResultView/ResultList/ProfileCards/search-card/Appointments/NextAvailable/NextAvailable.styles';

export const Label = styled(SearchLabel)`
  flex-grow: 1;
  font-size: 12px;
  margin: auto auto auto 8px;

  ${Breakpoint.MEDIUM} {
    font-size: auto;
    margin: auto 0;
  }
`;

export const NextAvailableView = styled(NextView)`
  ${onMobile} {
    flex-direction: row;
    margin: 0 0 0 8px;
  }
`;
